// removed by extract-text-webpack-plugin
module.exports = {"container":"UsersAndVideo-container","tabsContainer":"UsersAndVideo-tabsContainer"};